// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh2[data-v-7b7c6e7e] {\n  font-size: 1.2rem;\n}\n.w-full[data-v-7b7c6e7e]{\n  width:100%\n}\n", "",{"version":3,"sources":["webpack://./resources/js/Components/Rfp/RfpOccuredAt.vue"],"names":[],"mappings":";AAyDA;EACE,iBAAiB;AACnB;AACA;EACE;AACF","sourcesContent":["\nh2 {\n  font-size: 1.2rem;\n}\n.w-full{\n  width:100%\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
